import { useState } from 'react';
import { Button } from '@iwoca/orion';
import { t, Trans } from '@lingui/macro';
import { AddNewApplicationNavItem } from 'components/addNewApplication/AddNewApplicationNavItem';
import { useDashboard } from 'components/Dashboard/Dashboard.context';
import { HelpModal } from 'components/Navigation/Help/HelpModal';
import ConfusedGuyLookingAtHisLaptop from 'svg/ConfusedGuyLookingAtHisLaptop';
import GuyWithLaptopIcon from 'svg/GuyWithLaptopIcon';
import { useApplicationsTableState } from '../ApplicationsTableState.context';
import { TableLoader } from './TableLoader/TableLoader';
import styles from './TableStatus.module.css';

export const TableStatus = () => {
  const { table } = useApplicationsTableState();
  const { isLoading, state } = useDashboard();
  const [showHelpModal, setShowHelpModal] = useState(false);

  if (isLoading) {
    return <TableLoader />;
  }

  const hasFiltersApplied =
    table.getState().columnFilters.length > 0 || state.searchString;

  const tableStatus = hasFiltersApplied ? 'no-results' : 'empty';

  const statusConfig = {
    'no-results': {
      icon: <GuyWithLaptopIcon className={styles.icon} />,
      mainText: t`Your search returned no results`,
      extra: (
        <>
          <p className={styles.subText}>
            <Trans>
              Have you tried using different filters and checking for typos to
              see if that solves things?
            </Trans>
          </p>
          <p className={styles.subText}>
            <Trans>
              If you’re still not seeing what you expect,{' '}
              <Button
                variant="tertiary"
                onClick={() => setShowHelpModal(true)}
                className={styles.contactButton}
              >
                contact us
              </Button>{' '}
              for more support?
            </Trans>
          </p>
        </>
      ),
    },
    empty: {
      icon: <ConfusedGuyLookingAtHisLaptop className={styles.icon} />,
      mainText: t`You have no live applications`,
      extra: <AddNewApplicationNavItem className={styles.addButton} />,
    },
  } as const;

  const { icon, mainText, extra } = statusConfig[tableStatus];

  return (
    <div data-testid="table-mounted" className={styles.tableStatus}>
      <div className={styles.content}>
        {icon}
        <p className={styles.text}>{mainText}</p>
        {extra}
      </div>
      <HelpModal
        showModal={showHelpModal}
        closeModal={() => setShowHelpModal(false)}
      />
    </div>
  );
};
